import axios from 'axios';
import { API_BASE_URL, LAB_TOKEN } from './constants';

const axiosClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    'X-Tenant-Id': process.env.REACT_APP_X_TENANT_ID ?? '',
    'X-User-Type': 'lab_admin',
  },
});

// Optional: Add interceptors for auth, logging, etc.
axiosClient.interceptors.request.use((config) => {
  const token = localStorage.getItem(LAB_TOKEN);
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Response interceptor to handle 401 errors
axiosClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      // Clear token and user data
      localStorage.removeItem(LAB_TOKEN);
      localStorage.removeItem('user'); // if stored

      // Redirect to login page
      window.location.href = '/lab-login';
    } else {
      
    }
    return Promise.reject(error);
  }
);

export default axiosClient;
